import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { NavLink } from "react-router-dom-v5-compat";
import { useCompany } from "../../CompanyProvider/CompanyProvider";
import { maybeChangeHomeUrl } from "../../ConditionalLink";
import { NavDrawerMenuItem } from "../NavDrawerMenuItem";
import { AccountRoutesType, DefaultRoutesText } from "../navigationUtils";
export const NonAccountPageLinks = () => {
    const { url } = useCompany();
    const homeUrl = maybeChangeHomeUrl(url);
    return (_jsxs(Stack, Object.assign({ spacing: 1 }, { children: [_jsx(NavDrawerMenuItem, Object.assign({ component: NavLink, to: homeUrl, selected: false }, { children: _jsx(Typography, Object.assign({ variant: "h4" }, { children: DefaultRoutesText.HOME })) })), _jsx(NavDrawerMenuItem, Object.assign({ component: NavLink, to: AccountRoutesType.ORDERS, selected: location.pathname === AccountRoutesType.ORDERS }, { children: _jsx(Typography, Object.assign({ variant: "h4" }, { children: DefaultRoutesText.ACCOUNT })) }))] })));
};
